/* ============================================================================
   LAH — REPETIR AS LENTES DA ULTIMA COMPRA
   Tema: Outubro (Claude 5.0)

   Cliente logado com pedido anterior de lente ganha um botao acima do CTA
   principal. Ele confere o que sera montado e o fluxo vai direto ao resumo.

   ============================================================================
   SO AS LENTES — a receita saiu deste fluxo
   ============================================================================
   O painel tinha duas opcoes de receita: manter a do pedido anterior ou
   enviar uma nova. Ambas sairam, junto com a copia dos dados de grau, DP e
   arquivo entre pedidos.

   Por que: quase nenhum cliente recorrente tem receita vinculada ao perfil —
   o anexo passou a ser feito depois da compra, na area de conta. A pergunta
   aparecia oferecendo algo que na maioria das vezes nao existia, e o proprio
   botao ficava escondido de quem nao tinha esses dados.

   De quebra, some o risco de herdar um grau antigo sem o cliente perceber —
   num produto de saude visual, repetir a lente e seguro; repetir o grau de um
   ano atras nao e.

   Agora a promessa e menor e verdadeira: repetir A COMBINACAO DE LENTES nesta
   armacao. A receita segue o caminho normal da loja.

   ============================================================================
   O QUE O PAINEL MOSTRA
   ============================================================================
   Armacao desta pagina + lentes do pedido anterior, com o PRECO DE HOJE.

   NAO comparamos com o total do pedido antigo: a armacao e outra, entao a
   diferenca seria ruido num momento de decisao. Desconto, quando existe,
   aparece: esse sim e informacao util.

   Item que saiu do catalogo e listado como indisponivel e fica de fora, sem
   travar o resto.
   ============================================================================ */

(function () {
    'use strict';

    var dados = document.querySelector('[data-lah-repeat]');
    if (!dados) return;

    var root = document.querySelector('.product-lens-select');
    var cta = document.querySelector('.openProductLens');
    if (!root || !cta) return;

    function parsePares(texto) {
        var out = [];
        (texto || '').split('||').forEach(function (par) {
            if (!par) return;
            var i = par.indexOf('|');
            if (i === -1) return;
            out.push({ chave: par.slice(0, i), valor: par.slice(i + 1) });
        });
        return out;
    }

    var itensAnteriores = parsePares(dados.getAttribute('data-itens'));
    var pedidoNome = dados.getAttribute('data-pedido') || '';
    var pedidoData = dados.getAttribute('data-pedido-data') || '';
    var armacaoNome = dados.getAttribute('data-armacao-nome') || 'Armação';
    var armacaoPreco = parseInt(dados.getAttribute('data-armacao-preco'), 10) || 0;
    var armacaoCompare = parseInt(dados.getAttribute('data-armacao-compare'), 10) || 0;

    if (!itensAnteriores.length) return;

    function track(eventName, payload) {
        try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(Object.assign({ event: eventName }, payload || {}));
        } catch (e) { /* analytics nunca deve quebrar a venda */ }
    }

    function moeda(centavos) {
        return (centavos / 100).toLocaleString('pt-BR', {
            style: 'currency', currency: 'BRL'
        });
    }

    function acharOpcaoPorVariante(variantId) {
        var inputs = root.querySelectorAll('input[name="item-variant-id"]');
        for (var i = 0; i < inputs.length; i++) {
            if (inputs[i].value === String(variantId)) {
                var item = inputs[i].closest('.product-lens-select-item');
                if (item) return item;
            }
        }
        return null;
    }

    function valorInput(item, nome) {
        if (!item) return 0;
        var input = item.querySelector('input[name="' + nome + '"]');
        return input ? parseInt(input.value, 10) || 0 : 0;
    }

    /* Levanta o que ainda existe no catalogo e quanto custa hoje */
    function levantar() {
        var disponiveis = [];
        var indisponiveis = [];
        var total = armacaoPreco;
        var economia = 0;

        if (armacaoCompare > armacaoPreco) {
            economia += armacaoCompare - armacaoPreco;
        }

        itensAnteriores.forEach(function (it) {
            var opcao = acharOpcaoPorVariante(it.chave);
            if (!opcao) {
                indisponiveis.push(it.valor);
                return;
            }

            var preco = valorInput(opcao, 'item-variant-price');
            var compare = valorInput(opcao, 'item-variant-compare-price');

            total += preco;
            if (compare > preco) {
                economia += compare - preco;
            }

            disponiveis.push({
                item: opcao,
                nome: opcao.getAttribute('data-item-name') || it.valor,
                preco: preco
            });
        });

        return {
            disponiveis: disponiveis,
            indisponiveis: indisponiveis,
            total: total,
            economia: economia
        };
    }

    /* ---------------------------------------------------------------------
       PAINEL
       --------------------------------------------------------------------- */
    var overlay = null;

    function abrirPainel() {
        var lev = levantar();

        if (!lev.disponiveis.length) {
            var b = document.querySelector('.lah-rp-btn');
            if (b) b.remove();
            return;
        }

        var html = '<div class="lah-rp">' +
            '<button type="button" class="lah-rp__close" aria-label="Fechar" data-rp-fechar>&times;</button>' +
            '<h2 class="lah-rp__title">Repetir as lentes do pedido ' + pedidoNome + '</h2>' +
            '<p class="lah-rp__sub">Compra de ' + pedidoData + '. Veja como fica nesta armação.</p>';

        html += '<div class="lah-rp__row"><span>' + armacaoNome + '</span><span>' +
            moeda(armacaoPreco) + '</span></div>';

        lev.disponiveis.forEach(function (d) {
            html += '<div class="lah-rp__row"><span>' + d.nome + '</span><span>' +
                (d.preco > 0 ? moeda(d.preco) : 'incluso') + '</span></div>';
        });

        if (lev.indisponiveis.length) {
            html += '<div class="lah-rp__aviso"><strong>' + lev.indisponiveis.join(', ') +
                '</strong> não está mais disponível e ficará de fora. ' +
                'Você pode escolher um substituto depois, no próprio fluxo.</div>';
        }

        html += '<div class="lah-rp__precos">' +
            '<div class="lah-rp__preco-linha lah-rp__preco-linha--novo"><span>Total</span>' +
            '<strong>' + moeda(lev.total) + '</strong></div>';

        /* Desconto e a unica comparacao que entra: e ganho concreto. */
        if (lev.economia > 0) {
            html += '<p class="lah-rp__porque">Você economiza <strong>' +
                moeda(lev.economia) + '</strong> com os descontos em vigor.</p>';
        }

        html += '</div>';

        html += '<button type="button" class="lah-rp__cta" data-rp-confirmar>Montar meu pedido</button>' +
            '<p class="lah-rp__foot">Você pode trocar qualquer opção depois de montar.</p>' +
            '</div>';

        overlay = document.createElement('div');
        overlay.className = 'lah-rp-overlay is-open';
        overlay.innerHTML = html;
        document.body.appendChild(overlay);
        document.body.classList.add('hidden-scroll');

        overlay.addEventListener('click', function (event) {
            var t = event.target;

            if (t.closest('[data-rp-confirmar]')) {
                confirmar(lev);
                return;
            }

            if (t.closest('[data-rp-fechar]') || t === overlay) {
                fechar();
            }
        });

        track('lens_repetir_painel', {
            pedido: pedidoNome,
            itens: lev.disponiveis.length,
            indisponiveis: lev.indisponiveis.length,
            total: lev.total / 100
        });
    }

    function fechar() {
        if (!overlay) return;
        overlay.remove();
        overlay = null;
        document.body.classList.remove('hidden-scroll');
    }

    /* ---------------------------------------------------------------------
       MONTAGEM — lentes e, em seguida, direto ao resumo
       --------------------------------------------------------------------- */
    function clicarSequencia(lista, indice, aoTerminar) {
        if (indice >= lista.length) {
            if (aoTerminar) aoTerminar();
            return;
        }

        var alvo = lista[indice].item;
        var tentativas = 0;

        (function tentar() {
            var etapa = alvo.closest('.product-lens-select-step');
            var visivel = etapa && etapa.offsetParent !== null;

            if (visivel) {
                alvo.click();
                requestAnimationFrame(function () {
                    setTimeout(function () {
                        clicarSequencia(lista, indice + 1, aoTerminar);
                    }, 90);
                });
                return;
            }

            tentativas++;
            if (tentativas > 40) {
                if (aoTerminar) aoTerminar();
                return;
            }

            setTimeout(tentar, 60);
        })();
    }

    /* Depois das lentes o fluxo pode parar em Acessorios — que nao faz parte
       da "mesma compra de antes". Avancamos com o proprio botao do rodape,
       que e o caminho que o cliente usaria, em vez de forcar o estado. */
    function irParaResumo() {
        var tentativas = 0;

        (function tentar() {
            var botao = document.querySelector('.lens-footer-button');
            var acessorios = root.querySelector('[data-step-selector="accessories-step"]');
            var naEtapaAcessorios = acessorios && acessorios.offsetParent !== null;

            if (naEtapaAcessorios && botao) {
                botao.click();
                return;
            }

            tentativas++;
            if (tentativas > 25) return;

            setTimeout(tentar, 70);
        })();
    }

    function confirmar(lev) {
        track('lens_repetir_confirmado', { pedido: pedidoNome });

        fechar();
        cta.click();

        setTimeout(function () {
            clicarSequencia(lev.disponiveis, 0, irParaResumo);
        }, 260);
    }

    /* ---------------------------------------------------------------------
       BOTAO, acima do CTA principal
       --------------------------------------------------------------------- */
    var botao = document.createElement('button');
    botao.type = 'button';
    botao.className = 'lah-rp-btn';
    botao.innerHTML =
        '<span class="lah-rp-btn__icon">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M4 12a8 8 0 0 1 13-6.2"/><path d="M20 12a8 8 0 0 1-13 6.2"/>' +
        '<path d="M17 3.5v3h-3"/><path d="M7 20.5v-3h3"/></svg></span>' +
        '<span><span class="lah-rp-btn__title">Repetir as lentes da última compra</span>' +
        '<span class="lah-rp-btn__sub">Mesma combinação do pedido ' + pedidoNome + ', nesta armação</span></span>';

    botao.addEventListener('click', abrirPainel);
    cta.parentNode.insertBefore(botao, cta);
})();
